import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const appearance: IMcAppType = {
  name: "appearance",
  path: "/my/app-settings/appearance",
  description: "Appearance - allow user to set theme preferences",
  navFlow: NavFlow.STANDARD,
  title: "Appearance",
  parent: Tab.PROFILE,
};
